<template>
  <div id="app">
    <MainView></MainView>
  </div>
</template>

<script>
//import ApiService from "./services/api.service"
import MainView from "./components/Main.vue"

export default {
  name: 'App',
  components: {
     MainView
  },
  mounted(){
    //console.log(process.env.VUE_APP_BASEURL);
    //ApiService.init();
    
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
